import { configureStore } from "@reduxjs/toolkit";
import { todoApi } from "../features/todo/api/todoApi";
import todoSlice from "../features/todo/todoSlice";

const store = configureStore({
    reducer: {
        filter: todoSlice,
        [todoApi.reducerPath]: todoApi.reducer,
    },
    middleware: (getDefaultMidlleware) =>
        getDefaultMidlleware().concat(todoApi.middleware),
});

export default store;
